import React, { Component } from 'react';
import PropTypes from 'prop-types';
import history from 'utils/history';
import { observer, inject } from 'mobx-react';
import { Urls, Designers, Pagination } from 'apps/find-designers/propTypes';
import initTypeform from 'utils/initTypeform';
import Filters from './Filters';
import PageLayout from './PageLayout';
import ResultsPane from './ResultsPane';

class FindDesignersApp extends Component {
    constructor() {
        super();

        this.handleClear = this.handleClear.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        initTypeform();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            if (!this.props.filterStore.isQuerySet(nextProps.location.search)) {
                this.props.filterStore.setFiltersFromQueryString(nextProps.location.search);
            }
        }
    }

    handleChange(name, value) {
        this.props.filterStore.setValue(name, value);

        if (name === 'q') {
            // keyword filter
            history.replace(`/designers/search${this.props.filterStore.currentQueryString}`);
        } else {
            history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
        }
    }

    handleClear(e) {
        const { name, value } = e.target;

        this.props.filterStore.clearFilterOption(name, value);
        history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
    }

    handleReset() {
        this.props.filterStore.reset();
        history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
    }

    layoutChildren() {
        return (
            <div className="row">
                <div className="column small-12 medium-12 normal-3 large-3">
                    <Filters onChange={this.handleChange} />
                </div>
                <div className="column small-12 medium-12 normal-9 large-9">
                    <ResultsPane
                        searchString={this.props.location.search}
                        urls={this.props.urls}
                        designers={this.props.designers}
                        pagination={this.props.pagination}
                        storeFront={this.props.storeFront}
                        onReset={this.handleReset}
                        onClear={this.handleClear}
                        currentUser={this.props.currentUser}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (this.props.currentUser.isIdentified) {
            return <PageLayout navItems={this.props.navItems}>{this.layoutChildren()}</PageLayout>;
        }

        return (
            <div className="content-body">
                <div className="content-body__inner-1">
                    <div className="content-body__inner-2">{this.layoutChildren()}</div>
                </div>
            </div>
        );
    }
}

FindDesignersApp.propTypes = {
    filterStore: PropTypes.shape({
        setValue: PropTypes.func.isRequired,
        setFiltersFromQueryString: PropTypes.func.isRequired,
        clearFilterOption: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        isQuerySet: PropTypes.func.isRequired,
        currentQueryString: PropTypes.string.isRequired,
    }).isRequired,
    urls: Urls.isRequired,
    navItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            position: PropTypes.string.isRequired,
            active: PropTypes.string.isRequired,
        })
    ).isRequired,
    designers: Designers.isRequired,
    pagination: Pagination.isRequired,
    storeFront: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        featuredSearches: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                searchUrl: PropTypes.string.isRequired,
                designers: Designers.isRequired,
            })
        ).isRequired,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    currentUser: PropTypes.shape({
        isIdentified: PropTypes.bool.isRequired,
    }).isRequired,
};

FindDesignersApp.defaultProps = {
    designers: [],
};

export default inject('filterStore')(observer(FindDesignersApp));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FindDesignersApp.jsx